import { SVGProps, Ref, forwardRef } from 'react'
const SvgCake = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    width="1.5rem"
    height="1.5rem"
    fill="none"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M16.5 6.026a5.465 5.465 0 0 1 4.732 1.955v0a2.861 2.861 0 0 1-.921 4.1l-7.517 4.692a1.5 1.5 0 0 1-1.588 0L3.692 12.08a2.862 2.862 0 0 1-.921-4.1v0A5.465 5.465 0 0 1 7.5 6.026"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M2.25 9.768v5.947a3.191 3.191 0 0 0 1.44 2.365l7.516 4.692a1.5 1.5 0 0 0 1.588 0l7.516-4.692a3.19 3.19 0 0 0 1.436-2.365V9.768M12 6.018v6M14.25 3.768a2.25 2.25 0 0 1-4.5 0c0-1.242 2.25-3 2.25-3s2.25 1.758 2.25 3Z"
    />
  </svg>
)
const ForwardRef = forwardRef(SvgCake)
export default ForwardRef
